import React, { useState, useContext, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import "../styles/problems.css"
import { Context } from '../../context';
import { CLOUDINARYURL, makeDraggable } from '../../utils/constants'

export default function Problem(props) {
    const [data, setData] = useState(props.data)

    const history = useHistory()
    const context = useContext(Context)
    const handleClick = () => {
        let temp = context.currentProblemState
        temp[data._id] = data
        context.setCurrentProblemState(temp)
        history.push("/solve?id=" + data._id + "&prburl=" + data.problemUrl.slice(CLOUDINARYURL.length, data.problemUrl.length))
    }
    useEffect(() => {
        // makeDraggable(data._id)
        setData(props.data)
    }, [props])
    return (
        <div className="pb-each" onClick={handleClick} id={data._id} data-aos="flip-up" >
            <div className="pb-each-header">
                <h4>{data.title}</h4>
                <p><b>{data.solvedNum}</b> {data.solvedNum <= 1 ? "coder has" : "coders have"} solved</p>
            </div>
            <div className="pb-each-info">
                <span>Points:<span>{data.points}</span></span>
                <span>Difficulty: <span className={`pb-${data.difficulty}`} >{data.difficulty}</span></span>
            </div>
        </div>
    )
}